<template>
  <header class="header">
    <div class="wrapper">
      <div class="left">
        <router-link to="/" class="logo">
          <img src="./../img/logo.svg" class="img" />
        </router-link>
      </div>
      <ul class="nav">
        <li class="nav__item">
          <router-link class="desc" to="/rules">
            <b>{{ $t("Rules") }}</b>
          </router-link>
        </li>
        <li class="nav__item">
          <button class="desc" @click="$parent.openContactUs()">
            <b>{{ $t("Contact us") }}</b>
          </button>
        </li>
        <li
          :class="['nav__item', { active: $route.name == 'Products' }]"
          v-if="$parent.categories && $parent.categories.length"
        >
          <button
            @click="$emit('chooseCategoty', $parent.categories[0])"
            class="desc"
          >
            <b>{{ $t("Store") }}</b>
          </button>
        </li>
        <li class="nav__item">
          <router-link class="desc" to="/faq">
            <b>{{ $t("FAQ") }}</b>
          </router-link>
        </li>
      </ul>
      <div class="right">
        <LanguageSelectDropdown v-if="allLanguages > 1" />
        <select
          v-if="currencies.length && currencies.length > 1"
          class="currency-dropdown"
          v-model="selectedCurrency"
          @change="onCurrencyChange"
          :disabled="!currencies.length"
        >
          <option v-for="c in currencies" :key="c.code" :value="c.code">
            {{ c.code || c.symbol }}
          </option>
        </select>
        <router-link
          to="/cart"
          class="cart-icon button icon-button"
          v-if="$parent.isAuth"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_34_1543)">
              <path
                d="M19.7031 7.22904C19.439 6.89772 19.0428 6.70764 18.616 6.70764H14.7643L12.6756 1.9251C12.5461 1.62858 12.2007 1.49307 11.9042 1.62264C11.6076 1.75213 11.4722 2.09756 11.6017 2.39412L13.4855 6.70768H6.51449L8.39828 2.39412C8.52778 2.09756 8.39239 1.75217 8.09582 1.62264C7.7993 1.49307 7.45387 1.6285 7.32438 1.9251L5.23574 6.70768H1.38403C0.957229 6.70768 0.561018 6.89772 0.296917 7.22908C0.0376587 7.5544 -0.0580054 7.9726 0.0344556 8.37658L2.09137 17.361C2.235 17.9883 2.78996 18.4264 3.44094 18.4264H16.5591C17.21 18.4264 17.765 17.9883 17.9086 17.361L19.9655 8.37654C20.058 7.97256 19.9623 7.55436 19.7031 7.22904ZM16.5591 17.2545H3.44094C3.34145 17.2545 3.2543 17.1893 3.23371 17.0994L1.1768 8.11506C1.16067 8.04455 1.18774 7.99151 1.21336 7.95944C1.23711 7.92959 1.2909 7.87955 1.38403 7.87955H4.72399L4.57051 8.231C4.44102 8.52756 4.57641 8.87295 4.87297 9.00248C4.9493 9.03584 5.02883 9.05162 5.10715 9.05162C5.33301 9.05162 5.54824 8.92026 5.64442 8.70006L6.00274 7.87963H13.9973L14.3557 8.70006C14.4518 8.9203 14.6671 9.05162 14.8929 9.05162C14.9712 9.05162 15.0508 9.03584 15.1271 9.00248C15.4237 8.87299 15.5591 8.52756 15.4296 8.231L15.2761 7.87955H18.6161C18.7092 7.87955 18.763 7.92959 18.7867 7.95944C18.8123 7.99154 18.8394 8.04459 18.8233 8.11502L16.7664 17.0994C16.7457 17.1893 16.6586 17.2545 16.5591 17.2545Z"
                fill="white"
              />
              <path
                d="M6.48438 10.4186C6.16078 10.4186 5.89844 10.6809 5.89844 11.0045V15.3014C5.89844 15.625 6.16078 15.8873 6.48438 15.8873C6.80797 15.8873 7.07031 15.625 7.07031 15.3014V11.0045C7.07031 10.6809 6.80801 10.4186 6.48438 10.4186Z"
                fill="white"
              />
              <path
                d="M10 10.4186C9.67641 10.4186 9.41406 10.6809 9.41406 11.0045V15.3014C9.41406 15.625 9.67641 15.8873 10 15.8873C10.3236 15.8873 10.5859 15.625 10.5859 15.3014V11.0045C10.5859 10.6809 10.3236 10.4186 10 10.4186Z"
                fill="white"
              />
              <path
                d="M13.5156 10.4186C13.192 10.4186 12.9297 10.6809 12.9297 11.0045V15.3014C12.9297 15.625 13.192 15.8873 13.5156 15.8873C13.8392 15.8873 14.1016 15.625 14.1016 15.3014V11.0045C14.1015 10.6809 13.8392 10.4186 13.5156 10.4186Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_34_1543">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <div v-if="$parent.cartContents.length" class="indicator">
            {{ $parent.cartContents.length }}
          </div>
        </router-link>
        <router-link
          to="/profile"
          class="profile-icon button icon-button"
          v-if="$parent.isAuth"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.85724 9.63408C11.1808 9.63408 12.3267 9.15938 13.2633 8.22279C14.1996 7.28636 14.6744 6.14058 14.6744 4.81689C14.6744 3.49365 14.1997 2.34771 13.2632 1.41098C12.3266 0.4747 11.1806 0 9.85724 0C8.53354 0 7.38776 0.4747 6.45132 1.41113C5.51489 2.34756 5.04004 3.49349 5.04004 4.81689C5.04004 6.14058 5.51489 7.28652 6.45132 8.22295C7.38806 9.15922 8.534 9.63408 9.85724 9.63408ZM7.28018 2.23983C7.99872 1.5213 8.84161 1.17203 9.85724 1.17203C10.8727 1.17203 11.7158 1.5213 12.4344 2.23983C13.153 2.95852 13.5024 3.80157 13.5024 4.81689C13.5024 5.83251 13.153 6.6754 12.4344 7.39409C11.7158 8.11278 10.8727 8.46205 9.85724 8.46205C8.84192 8.46205 7.99902 8.11263 7.28018 7.39409C6.56149 6.67555 6.21207 5.83251 6.21207 4.81689C6.21207 3.80157 6.56149 2.95852 7.28018 2.23983Z"
              fill="white"
            />
            <path
              d="M18.2863 15.379C18.2593 14.9893 18.2047 14.5642 18.1242 14.1153C18.0431 13.663 17.9385 13.2354 17.8134 12.8447C17.684 12.4408 17.5084 12.0419 17.291 11.6597C17.0656 11.2629 16.8007 10.9175 16.5034 10.6332C16.1926 10.3358 15.8121 10.0967 15.372 9.9223C14.9335 9.74881 14.4475 9.66092 13.9276 9.66092C13.7234 9.66092 13.526 9.74469 13.1447 9.99295C12.91 10.146 12.6355 10.323 12.3291 10.5188C12.0671 10.6857 11.7122 10.8421 11.2738 10.9837C10.8461 11.1221 10.4118 11.1923 9.98306 11.1923C9.5546 11.1923 9.12033 11.1221 8.69232 10.9837C8.25439 10.8423 7.89932 10.6859 7.63779 10.5189C7.33429 10.325 7.05963 10.148 6.82144 9.9928C6.44043 9.74454 6.24298 9.66077 6.03882 9.66077C5.5188 9.66077 5.03296 9.74881 4.59457 9.92245C4.15482 10.0966 3.77411 10.3357 3.46298 10.6334C3.16574 10.9178 2.90085 11.2631 2.67563 11.6597C2.4585 12.0419 2.28271 12.4406 2.15332 12.8448C2.02835 13.2356 1.92383 13.663 1.84265 14.1153C1.76208 14.5636 1.70761 14.9888 1.6806 15.3794C1.65405 15.7614 1.64062 16.1589 1.64062 16.5605C1.64062 17.6045 1.9725 18.4497 2.62695 19.073C3.27332 19.6881 4.12842 19.9999 5.16861 19.9999H14.7987C15.8386 19.9999 16.6937 19.6881 17.3402 19.073C17.9948 18.4501 18.3267 17.6046 18.3267 16.5603C18.3266 16.1573 18.313 15.7598 18.2863 15.379ZM16.5321 18.2238C16.105 18.6303 15.538 18.8279 14.7986 18.8279H5.16861C4.42902 18.8279 3.862 18.6303 3.43506 18.224C3.0162 17.8253 2.81265 17.281 2.81265 16.5605C2.81265 16.1857 2.82501 15.8157 2.84973 15.4605C2.87384 15.112 2.92313 14.7291 2.99622 14.3223C3.06839 13.9206 3.16025 13.5435 3.2695 13.2022C3.37433 12.8749 3.5173 12.5508 3.69461 12.2386C3.86383 11.941 4.05853 11.6858 4.27338 11.4801C4.47433 11.2877 4.72763 11.1302 5.02609 11.0121C5.30212 10.9028 5.61234 10.843 5.9491 10.834C5.99014 10.8558 6.06323 10.8975 6.18164 10.9747C6.42258 11.1317 6.70029 11.3108 7.00729 11.5069C7.35336 11.7276 7.79922 11.9268 8.33191 12.0988C8.8765 12.2749 9.43192 12.3643 9.98322 12.3643C10.5345 12.3643 11.0901 12.2749 11.6344 12.099C12.1675 11.9267 12.6132 11.7276 12.9597 11.5066C13.2739 11.3058 13.5439 11.1319 13.7848 10.9747C13.9032 10.8976 13.9763 10.8558 14.0173 10.834C14.3542 10.843 14.6645 10.9028 14.9406 11.0121C15.239 11.1302 15.4922 11.2878 15.6932 11.4801C15.9081 11.6856 16.1028 11.9409 16.272 12.2387C16.4494 12.5508 16.5926 12.875 16.6972 13.202C16.8066 13.5438 16.8987 13.9207 16.9707 14.3222C17.0436 14.7297 17.093 15.1127 17.1172 15.4606V15.4609C17.142 15.8148 17.1545 16.1846 17.1547 16.5605C17.1545 17.2811 16.951 17.8253 16.5321 18.2238Z"
              fill="white"
            />
          </svg>
        </router-link>
        <div class="link-container" v-else>
          <button class="button" @click="$parent.openSignIn()">
            {{ $t("Log in") }}
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import useCurrency from "../utils/useCurrency";
import LanguageSelectDropdown from "@/components/LanguageSelectDropdown.vue";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";

export default {
  name: "Header",
  props: [],
  data: function () {
    return {
      selectedCurrency: "",
      currencies: [],
    };
  },
  components: {
    LanguageSelectDropdown,
  },
  computed: {
    ...mapState({
      languages: ({ app: { languages } }) =>
        languages.map(({ id, title: text }) => ({ id, text })),
      currentLanguage: (state) => state.app.currentLanguage,
    }),
    ...mapGetters("app", ["currentLanguageName", "allLanguages"]),
    language: {
      set(langId) {
        this.changeLocale(langId);
      },
      get() {
        return this.currentLanguage;
      },
    },
  },
  methods: {
    ...mapMutations("app", ["setCurrentLanguage"]),
    ...mapActions("app", ["changeLocale"]),
    onCurrencyChange() {
      const currencyService = useCurrency();
      currencyService.setCurrency(this.selectedCurrency);
      this.selectedCurrency = currencyService.getCurrencyCode();
    },
    loadCurrencies() {
      const currencyService = useCurrency();
      this.currencies = currencyService.currencies.value;
      this.selectedCurrency = currencyService.getCurrencyCode();
    },
  },
  mounted() {
    const currencyService = useCurrency();

    if (
      currencyService.isLoaded.value &&
      currencyService.currencies.value.length
    ) {
      this.selectedCurrency = currencyService.getCurrencyCode();
      this.currencies = currencyService.currencies.value;
    } else {
      const unwatch = currencyService.onCurrencyChange(() => {
        this.selectedCurrency = currencyService.getCurrencyCode();
        this.currencies = currencyService.currencies.value;
        unwatch && unwatch();
      });
    }

    currencyService.onCurrencyChange(() => {
      this.selectedCurrency = currencyService.getCurrencyCode();
      this.currencies = currencyService.currencies.value;
    });
  },
  watch: {
    selectedCurrency(newVal) {
      const currencyService = useCurrency();
      if (!this.currencies.find((c) => c.code === newVal)) {
        this.selectedCurrency = currencyService.getCurrencyCode();
      }
    },
  },
};
</script>

<style scoped>
.currency-dropdown {
  width: fit-content;
  margin-right: 16px;
  border: 1px solid #22a8fd;
  border-radius: 20px;
  padding: 6px 18px;
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #22a8fd;
  background: #f9f9f9;
  outline: none;
  transition: border 0.2s;
  cursor: pointer;
}
.currency-dropdown:focus {
  border-color: #011525;
}
.currency-dropdown:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
